var AccessCodes = /* @__PURE__ */ ((AccessCodes2) => {
  AccessCodes2[AccessCodes2["ALLOWED"] = 0] = "ALLOWED";
  AccessCodes2[AccessCodes2["AUTHENTICATION_REQUIRED"] = 1] = "AUTHENTICATION_REQUIRED";
  AccessCodes2[AccessCodes2["LICENSE_REQUIRED"] = 2] = "LICENSE_REQUIRED";
  AccessCodes2[AccessCodes2["GUEST_ONLY"] = 4] = "GUEST_ONLY";
  AccessCodes2[AccessCodes2["STUDENT_FORBIDDEN"] = 8] = "STUDENT_FORBIDDEN";
  AccessCodes2[AccessCodes2["TEACHER_FORBIDDEN"] = 16] = "TEACHER_FORBIDDEN";
  AccessCodes2[AccessCodes2["SKOLETUBE_REQUIRED"] = 32] = "SKOLETUBE_REQUIRED";
  AccessCodes2[AccessCodes2["SKOLETUBE_FORBIDDEN"] = 64] = "SKOLETUBE_FORBIDDEN";
  return AccessCodes2;
})(AccessCodes || {});

export { AccessCodes };
//# sourceMappingURL=typings.access-codes.js.map
